<template>
  <div>
    <div style="display: flex; align-items: center; gap: 10px;margin-left: 20px">
      <el-input
        placeholder="请输入内容"
        prefix-icon="el-icon-search"
        v-model="input1"
        style="width: 18%">
      </el-input>
      <el-button type="success" @click="mhSelect">查询</el-button>
    </div>
    <div>
  <el-table
    :data="tableData"
    height="480"
    border
    style="width: 97%;margin-top: 40px;margin-left: 20px">
    <el-table-column
      prop="id"
      label="序号"
      width="150">
    </el-table-column>
    <el-table-column
      prop="equ_id"
      label="设备ID"
      width="210">
    </el-table-column>
    <el-table-column
      prop="equ_name"
      label="设备名"
      width="180">
    </el-table-column>
    <el-table-column
      prop="companyId"
      label="企业ID"
      width="220">
    </el-table-column>
    <el-table-column
      prop="company"
      label="所属企业"
      width="220">
    </el-table-column>
    <el-table-column
      label="操作"
      width="220">
      <template slot-scope="scope">
        <el-button
          @click="handleClick(scope.row)"
          type="text"
          size="small">
          <span class="button-text">查看数据曲线</span>
          <img src="../assets/img/seach.svg" alt="搜索图标" class="button-icon">
        </el-button>
      </template>
    </el-table-column>
  </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tableData: [],
      input1:''
    }
  },
  methods:{
    handleClick(row){
      console.log('scope 对象包含很多信息，这里通过 row 参数传入了具体的行数据，以下是 row 的值：', row);
      this.$router.push({
        path:'/menu/allEquEnergy', // 路径
        query:{
          equ_id : row.equ_id,
          company : row.company,
          equ_name : row.equ_name
        }, //查询参数
      })
      // this.$router.push('/menu/allEquEnergy')
    },
    get_all_devices(){
      axios.get('/otherApi/get_all_devices')
        .then(res => {
          console.log(res)
          const data = res.data.data
          // 这里将获取到的数据赋值给tableData
          this.tableData = data.map(item => ({
            id: item.id,
            equ_id: item.equ_id,
            equ_name: item.equ_name,
            companyId: item.equ_company_id,
            company: item.name
          }));
        })
        .catch(error => {
          console.error('查询错误', error);
        });
    },
    //模糊查询
    mhSelect(){
      axios.get('/otherApi/get_search_devices',{
        params:{
          cname: this.input1
        }
      }).then(res => {
        console.log(res)
        const data = res.data.data;
        // 将模糊查询结果赋值给 tableData
        this.tableData = data.map(item => ({
          id: item.id,
          equ_id: item.equ_id,
          equ_name: item.equ_name,
          companyId: item.equ_company_id,
          company: item.name
        }));
      })
    }
  },
  mounted() {
    this.get_all_devices();
  }
}
</script>
<style scoped>
.button-text {
  vertical-align: middle; /* 垂直居中对齐 */
  font-size: 12px;
}

.button-icon {
  vertical-align: middle;
  margin-left: 8px; /* 图标与文字之间的间距 */
  width: 17px; /* 根据需要调整图标大小 */
  height: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/AllEquTable.vue